import React, {useEffect} from 'react';
import {Button} from '@mui/material';
import {useIntl} from 'react-intl';
import {SVGS} from '../../../assets/images';
import styles from '../time-tracking-import.module.scss';
import {setIndicatorLoading} from '../../../features/indicator';
import {Lx} from '../../../i18n/consts';

interface TimeTrackingImportUploadCardProps {
    isReadingFile: boolean;
    isTemplateLoading: boolean;
    onOpenFileDialog: () => void;
    onDownloadTemplate: () => void;
}

export default function TimeTrackingImportUploadCard({
    isReadingFile,
    isTemplateLoading,
    onOpenFileDialog,
    onDownloadTemplate,
}: TimeTrackingImportUploadCardProps) {
    const intl = useIntl();

    useEffect(() => {
        setIndicatorLoading(isReadingFile);

        return () => {
            setIndicatorLoading(false);
        };
    }, [isReadingFile]);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onOpenFileDialog();
        }
    };

    return (
        <section className={styles.card}>
            <div className={styles.cardHeader}>
                <div>
                    <h3>Upload file</h3>
                    <p>Use csv or xlsx. For the current test format default columns are already prepared.</p>
                </div>
            </div>
            <div
                className={styles.dropzone}
                role='button'
                tabIndex={0}
                onClick={onOpenFileDialog}
                onKeyDown={handleKeyDown}
            >
                {!isReadingFile ? (
                    <>
                        <SVGS.AddChartIcon className={styles.dropzoneIcon} />
                        <div className={styles.dropzoneTitle}>Choose file</div>
                        <div className={styles.dropzoneHint}>
                            Expected columns: Expert, Date, Hours, Project/Absence, Type, Comment.
                        </div>
                    </>
                ) : null}
            </div>
            <div className={styles.templateRow}>
                <p className={styles.templateHint}>
                    {intl.formatMessage({id: Lx.TimeTrackingImport.DOWNLOAD_TEMPLATE_HINT})}
                </p>
                <Button
                    className={styles.secondaryButton}
                    variant='outlined'
                    disabled={isTemplateLoading}
                    onClick={onDownloadTemplate}
                >
                    {intl.formatMessage({id: Lx.TimeTrackingImport.DOWNLOAD_TEMPLATE})}
                </Button>
            </div>
        </section>
    );
}
